import url_ from "asset-data:assets/galleries/ua-2021-12-09/L1000975-bw_34ca27f86a__400.jpg";
export const url = url_;